var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScribble1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 16,
    viewBox: "0 0 283 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222.727 2C123.135 1.99972 18.9271 5.66529 10.7462 6.64982C2.56524 7.63435 185.999 6.80027 216.018 7.82889C223.754 8.09397 281.352 9.2004 280.998 9.66881C280.205 10.7189 49.6752 7.50321 2.00001 14",
    stroke: "#067FE5",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScribble1);
export default __webpack_public_path__ + "static/media/scribble-1.b364f160f26e5379c28fdcd8ed09836d.svg";
export { ForwardRef as ReactComponent };